import { Component, Inject, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MasterService } from "@frontend/app/serivces/master.service";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { FormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatOptionModule } from "@angular/material/core";
import { MatCheckbox } from "@angular/material/checkbox";
import { ToastrService } from "@frontend/app/serivces/toastr.service";
import { MultiSelectDropdownComponent } from "@frontend/app/components/multi-select-dropdown/multi-select-dropdown.component";

@Component({
  selector: "app-permission-edit",
  imports: [CommonModule, FormsModule, MatSelectModule, MatFormFieldModule, MatOptionModule, MultiSelectDropdownComponent],
  templateUrl: "./permission-edit.component.html",
  styleUrl: "./permission-edit.component.scss",
})
export class PermissionEditComponent implements OnInit {
  private masterService = inject(MasterService);
  private toasterService = inject(ToastrService);
  private dialog = inject(MatDialog);

  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    this.UMID = data.UMID;
  }

  ngOnInit(): void {
    this.getUserByID();
    this.getUserTypeList();
  }

  //#region variables
  UMID: any;
  userDetails: Array<any> = [];
  userTypeList: Array<any> = [];
  //#endregion
  getUserByID() {
    this.masterService.getUserByID(this.UMID).subscribe(res => {
      const { Table } = res;
      this.userDetails = (Array.isArray(Table) ? Table : [Table]).map(user => ({
        ...user,
        UserTypeIDs: user.UserTypeID ? user.UserTypeID.toString().split(",").map(Number) : [],
      }));
    });
  }

  getUserTypeList() {
    this.masterService.getUserTypeList().subscribe(res => {
      const { Table } = res;
      this.userTypeList = Table.filter((item:any) => item.UserTypeID <= 3);
    });
  }

  onTypeToggle(item: any, selectedID: number) {
    if (!item.UserTypeIDs) {
      item.UserTypeIDs = [];
    }

    const index = item.UserTypeIDs.indexOf(selectedID);
    if (index === -1) {
      item.UserTypeIDs.push(selectedID);
    } else {
      item.UserTypeIDs.splice(index, 1);
    }
  }

  getUserTypeName(id: number): string {
    const match = this.userTypeList.find(x => x.UserTypeID === id);
    return match ? match.UserType : "";
  }

  getSelectedNames(ids: number[]): string {
    return ids.map(id => this.getUserTypeName(id)).join(", ");
  }

  onSubmit(item: any) {
    const payload = {
      UMID: item.UMID || 0,
      UserRoleID: item.UserTypeIDs || []
    };
    this.masterService.updateUserAccess(payload).subscribe(res => {
      this.toasterService.success("User Updated Successfully");
      this.dialog.closeAll();
    });
  }

  onClose() {
    this.dialog.closeAll();
  }
}
